export default [
    { path: '*', redirect: '/' }
  ]



// WEBPACK FOOTER //
// ./src/router/common.js